// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Warp Gates Configuration - Universe Discworld
 * 
 * Magical portals and dimensional gateways in the Discworld universe
 * Where L-Space connects all libraries and magic makes travel possible
 */

export const warpGates = [
  {
    id: 'gate_discworld_to_milkyway',
    name: 'SOL GATEWAY',
    distance: 15,
    threat: 'SAFE',
    resources: 'SCIENCE PORTAL',
    services: [],
    description: 'A portal to the Milky Way galaxy. Where science works properly (mostly).',
    type: 'warpgate',
    discovered: false,
    destinationUniverse: 'milkyway',
    destinationGate: 'gate_milkyway_to_discworld',
    toSystem: 0,
    fuelRequired: 5,
    primaryColor: '#8B4513',
    secondaryColor: '#FFD700',
    hasRings: true,
    animated: true,
  },
  {
    id: 'gate_discworld_to_lspace',
    name: 'L-SPACE PORTAL',
    distance: 30,
    threat: 'NARRATIVE',
    resources: 'KNOWLEDGE',
    services: ['refuel', 'trade'],
    description: 'A portal through L-Space, where all libraries are connected. Ook!',
    type: 'warpgate',
    discovered: true,
    destinationUniverse: 'lspace',
    destinationGate: 'gate_lspace_to_discworld',
    toSystem: 800,
    fuelRequired: 5,
    primaryColor: '#8B4513',
    secondaryColor: '#FFD700',
    hasRings: true,
    animated: true,
  },
  {
    id: 'gate_discworld_to_dungeon',
    name: 'DUNGEON DIMENSIONS RIFT',
    distance: 280,
    threat: 'ELDRITCH',
    resources: 'PURE CHAOS',
    services: ['refuel'],
    description: 'A dangerous rift to the spaces between spaces. Not recommended for casual travel.',
    type: 'warpgate',
    discovered: false,
    destinationUniverse: 'dungeon-dimensions',
    destinationGate: 'gate_dungeon_to_discworld',
    toSystem: 100,
    fuelRequired: 5,
    primaryColor: '#4B0082',
    secondaryColor: '#8B00FF',
    hasRings: true,
    animated: true,
  },
  {
    id: 'gate_discworld_to_improbability',
    name: 'IMPROBABILITY SECTOR GATEWAY',
    distance: 45,
    threat: 'RULES',
    resources: 'SCIENCE',
    services: ['refuel', 'trade'],
    description: 'A stable portal to the Improbability Sector, where the laws of physics are more like guidelines.',
    type: 'warpgate',
    discovered: true,
    destinationUniverse: 'improbability',
    destinationGate: 'gate_improbability_to_discworld',
    toSystem: 300,
    fuelRequired: 5,
    primaryColor: '#FF00FF',
    secondaryColor: '#00FFFF',
    hasRings: true,
    animated: true,
  },
  {
    id: 'gate_discworld_to_zelda',
    name: 'Heroic Gateway',
    distance: 28,
    threat: 'SAFE',
    resources: 'ANCIENT PORTAL',
    services: [],
    description: 'A portal to a land of actual heroes (not the satirical kind). Ook!',
    type: 'warpgate',
    discovered: false,
    destinationUniverse: 'zelda',
    destinationGate: 'gate_zelda_to_discworld',
    toSystem: 1200,
    fuelRequired: 5,
    primaryColor: '#00FF00',
    secondaryColor: '#FFD700',
    hasRings: true,
    animated: true,
  },
];

export const warpGatePositions = {
  'gate_discworld_to_milkyway': { x: 48, y: 58, z: 6 },
  'gate_discworld_to_lspace': { x: 40, y: 45, z: 8 },
  'gate_discworld_to_dungeon': { x: 86, y: 56, z: 8 },
  'gate_discworld_to_improbability': { x: 55, y: 35, z: 10 },
  'gate_discworld_to_zelda': { x: 25, y: 35, z: 5 }
};